import { Box, Text, VStack } from "native-base";
import { COMMONFONTSIZE, COMMONFONTWEIGHT } from "../../utils/fonts";
import { COLORS } from "../../utils/colors";
import ContainerCards from "../cards";
import { noPhotosUploadedSVG } from "../../utils/svg";

const NoDataFound = ({ events = false, dataName = "", image = true, fullHeight = false, customMessage = false }) => {
  if (!image)
    return (
      <Text
        fontWeight={COMMONFONTWEIGHT.MEDIUM_FONT_WEIGHT}
        fontSize={"20px"}
        color={COLORS.ACCORDION_TITLE_COLOR}
        textAlign={"center"}
        justifyContent={"center"}
        alignItems={"center"}
      >
        No {dataName} available
      </Text>
    );
  else
    return (
      <ContainerCards
        background={COLORS.WHITE_COLOR}
        boxShadow="0px 18.953px 47.382px 0px rgba(119, 115, 170, 0.10)"
        height={fullHeight ? "100vh" : "auto"}
        alignItems={"center"}
        width="100%"
      >
        <Box p={fullHeight ? 0 : 6} w={"100%"} py={fullHeight ? "20vh" : (!events ? "100px" : "20px")}>
          <VStack alignItems={"center"} space={4}>
            {noPhotosUploadedSVG}
            <Box alignItems={"center"}>
              {/* <Text
                fontSize={COMMONFONTSIZE.EXTRA_LARGE_FONT_SIZE}
                fontWeight={COMMONFONTWEIGHT.MEDIUM_LARGE_FONT_WEIGHT}
                color={COLORS.ACCORDION_TITLE_COLOR}
              >
                Empty
              </Text> */}
              <Text
                fontSize={COMMONFONTSIZE.EXTRA_LARGE_FONT_SIZE}
                fontWeight={COMMONFONTWEIGHT.MEDIUM_FONT_WEIGHT}
                color={COLORS.BLACK_COLOR}
              >
                {customMessage ? dataName : `No ${dataName} available`}
              </Text>
            </Box>
          </VStack>
        </Box>
      </ContainerCards>
    );
};

export default NoDataFound;
